import React from "react";
import { FaMapMarkerAlt, FaStar } from "react-icons/fa";

const HotelDetailSidebar = ({ isAuthenticated, hotelName, city, address, hotelId, onLoginClick, isMobile = false }) => {
    return (
        <div style={{ width: isMobile ? "100%" : "280px", flexShrink: 0 }}>
            {/* Login Banner - More Compact */}
            {!isAuthenticated && (
                <div style={{
                    background: "linear-gradient(135deg, #EE2E24 0%, #FFB400 100%)",
                    borderRadius: "16px",
                    padding: isMobile ? "14px" : "18px",
                    marginBottom: "20px",
                    boxShadow: "0 8px 20px rgba(238, 46, 36, 0.15)",
                    color: "#fff",
                    position: "relative",
                    overflow: "hidden"
                }}>
                    <h4 style={{ fontSize: isMobile ? "0.9rem" : "1rem", fontWeight: "900", marginBottom: "8px", lineHeight: "1.2" }}>
                        Unlock Member Rates
                    </h4>
                    <p style={{ fontSize: isMobile ? "0.72rem" : "0.75rem", opacity: 0.9, marginBottom: "15px" }}>
                        Sign in to save up to 25% on your booking today.
                    </p>
                    <button
                        onClick={onLoginClick}
                        style={{
                            width: "100%",
                            padding: "10px",
                            background: "#fff",
                            color: "#EE2E24",
                            fontWeight: "900",
                            border: "none",
                            borderRadius: "10px",
                            cursor: "pointer",
                            textTransform: "uppercase",
                            fontSize: isMobile ? "0.72rem" : "0.75rem",
                            transition: "all 0.2s"
                        }}
                    >
                        LOGIN & SAVE
                    </button>
                </div>
            )}

            {/* Location Mini Widget - Compact */}
            <div style={{ background: "#fff", borderRadius: "12px", padding: isMobile ? "12px" : "15px", boxShadow: "0 4px 15px rgba(0,0,0,0.03)", marginBottom: "20px", border: "1px solid #f5f5f5" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <FaMapMarkerAlt style={{ color: "#EE2E24", fontSize: "0.9rem" }} />
                        <div style={{ fontWeight: "800", fontSize: "0.85rem", color: "#1a1a1a" }}>{city}</div>
                    </div>
                </div>
                <div
                    style={{
                        height: "100px",
                        background: "url('https://media.wired.com/photos/59269cd37034dc5f91bec0f1/master/pass/GoogleMapTA.jpg') center/cover",
                        borderRadius: "10px",
                        position: "relative"
                    }}
                >
                    <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.1)", borderRadius: "10px" }} />
                    <button
                        style={{ position: "absolute", bottom: "10px", left: "50%", transform: "translateX(-50%)", background: "#fff", border: "none", padding: "4px 12px", borderRadius: "20px", fontSize: "0.65rem", fontWeight: "900", color: "#EE2E24", cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}
                        onClick={() => window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${hotelName}, ${address || city}, Rajasthan`)}`, "_blank")}
                    >
                        EXPLORE MAP
                    </button>
                </div>
            </div>

            {/* Safety Banner */}
            <div style={{ background: "rgba(39, 174, 96, 0.05)", borderRadius: "12px", padding: isMobile ? "12px" : "15px", border: "1px dashed #27ae60" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "5px" }}>
                    <span style={{ color: "#27ae60", fontSize: "0.9rem" }}>🛡️</span>
                    <span style={{ fontSize: "0.75rem", fontWeight: "900", color: "#27ae60", letterSpacing: "0.5px" }}>HYGIENE PLUS</span>
                </div>
                <p style={{ fontSize: "0.75rem", color: "#555", margin: 0 }}>
                    Fully sanitized property with contactless check-in.
                </p>
            </div>
        </div>
    );
};

export default HotelDetailSidebar;
